// JS
import React from 'react';
import { randomId } from '../shared/utils';

const CategoriesBrands = ({
  data,
  gaBlockName,
  categoryBrandOptions,
  showCategoryBrand
}) => {
  const uniqueId = randomId();

  return data && data.revealed === 'revealed' ? (
    <section
      id={'creative-feature-' + uniqueId}
      className={
        showCategoryBrand
          ? 'container pr-0 md:!pr-12' +
            (categoryBrandOptions?.classes
              ? ' ' + categoryBrandOptions.classes
              : '')
          : 'hidden'
      }
    >
      <div
        className="flex flex-col gap-6 md:gap-8 items-start justify-center w-full"
        data-name={data.title}
        data-creative={gaBlockName}
        data-id={'bf-category-brand-' + data.contentguid}
        data-position={'banner-slot-1'}
        data-type="banner"
      >
        <h3 className="font-sans tracking-normal text-black text-lg font-bold leading-normal">
          {data.title}
        </h3>
        <div className="relative flex flex-row justify-start gap-x-6 gap-y-8 w-full no-scrollbar overflow-auto md:overflow-visible m-0 pl-0 pr-4 md:p-0 md:flex-wrap">
          {data.reference.map((button, index) => (
            <a
              key={
                button.category_or_brand === 'category'
                  ? 'bf-category-' + index
                  : 'bf-brand-' + index
              }
              href={button.link_raw}
              target="_self"
              rel="noreferrer"
              className="relative flex flex-row flex-shrink-0 gap-3 items-center justify-center text-black bg-blackFriday2 rounded-lg text-center w-fit hover:text-blackFriday2 hover:bg-black duration-500"
              data-name={button.block_title}
              data-creative={gaBlockName}
              data-id={button.contentguid}
              data-position={'button-slot-' + (index + 1)}
              data-type="banner-button"
            >
              {button.category_or_brand === 'category' && button.sku && (
                <div className="h-auto w-20">
                  <img
                    src={`https://www.sevenstore.com/images/products/thumbnail/${button.sku}.jpg`}
                    alt={button.title}
                    className="relative w-full h-auto object-cover object-center"
                  />
                </div>
              )}
              <div
                className={`text-lg text-left py-2 pl-4 pr-7 ${
                  button.category_or_brand === 'brand' && '!py-4 !px-8'
                }`}
              >
                <h3 className="font-base capitalize tracking-normal m-0 p-0">
                  {button.title}
                </h3>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  ) : null;
};

export default CategoriesBrands;
